import { QueryClient } from '@tanstack/react-query'

import { ApiError } from './errors'

/**
 * Shared query configuration.
 *
 * Retrying a 401 or a 403 is pointless — the answer will not change until the
 * operator signs in again — and retrying a 4xx write can duplicate work, so
 * only genuinely transient failures are retried.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false
        }
        return failureCount < 2
      },
      refetchOnWindowFocus: false,
    },
    mutations: { retry: false },
  },
})
